import { ResponceDataType } from "../ErrorCode";

export type ALM_KIND_SET = {
    TYP_NO: number;
    MCLC_TYP_ID: number;
    TYP_NAME: string;
    GUIDE_MSG: string;
    GUIDE_MSGL: string;

    isEdit: boolean;
}

// ALM_KIND_SET
export const GetAlmKindSetType = (): Promise<ALM_KIND_SET[]> => {
    return new Promise((resolve, reject) => {
        const url = "api/AlmKindSet";
        fetch(url)
            .then((res) => res.json())
            .then((result: ALM_KIND_SET[]) => {
                console.debug(result);
                if (result != null) {
                    if (result.length !== 0) {
                        result.map((row, index) => {
                            row.isEdit = false;
                        });
                        console.debug(["--result--", result]);
                    }
                    resolve(result);
                    if (AlmKindSetTypeValidate(result)) resolve(result);
                    reject('Invalidate response');
                }
                else {
                    reject('Invalidate response');
                }

            }
            ).catch((error) => {
                console.error(error);
                reject(error);
            });
    });
};

const AlmKindSetTypeValidate = (data: ALM_KIND_SET[]) => {
    if (data == undefined) return false;
    return true;
};

export const SetAlmKindSetType = (list: ALM_KIND_SET[]): Promise<ResponceDataType> => {
    return new Promise((resolve, reject) => {
        list = list.filter((r) => r.isEdit == true);
        fetch('api/AlmKindSet', {
            method: 'put',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(list),
        }).then((res) => {
            if (!res.ok) {
                let message = `データが見つかりませんでした status:${res.status}`;
                reject(message);
            }
            return res.json();
        }).then((result: ResponceDataType) => {
            console.debug(["SetAlmKindSetType -result", result])
            resolve(result);
        },
            (error) => {
                console.error(error);
                reject(error);
            })
    });
}